import type { useProposalStudio } from './useProposalStudio'

type Studio = ReturnType<typeof useProposalStudio>

export function ProposalStudioSlideSelector({ s }: { s: Studio }) {
  if (s.proposalItems.length <= 1 && s.comboVariations.length === 0) return null
  return (
    <div className="flex flex-col gap-1 bg-white/[0.02] border border-white/[0.06] p-3 rounded-lg">
      <label className="text-[10px] text-text-label uppercase tracking-wider font-semibold">
        Selecione o Slide/Opção para Customizar
      </label>
      <select
        value={s.activeIndex}
        onChange={(e) => s.setActiveIndex(Number(e.target.value))}
        className="w-full bg-[var(--glass-bg)] border border-[var(--glass-border)] text-text-primary rounded-md px-3 py-1.5 outline-none text-xs font-semibold cursor-pointer"
      >
        {s.slideOptions.map((opt) => (
          <option key={opt.value} value={opt.value} className="bg-[#16161a]">
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  )
}
